import getFileNameNoExtension from './getFileNameNoExtension'

const getFileWithSheetName = (fileName, sheetRead, pkID) => {
    const isExcel = fileName.split('.').pop() !== "csv" && fileName.split('.').pop() !== "txt";
    const sheetName = isExcel ? "- " + sheetRead[pkID] : "";

    return getFileNameNoExtension(fileName) + sheetName
}

export default getFileWithSheetName